module.exports = __webpack_public_path__ + "img/Blog1.da46bebf.png";